import { render, staticRenderFns } from "./PerfilAcessoEdit.vue?vue&type=template&id=6c5000ed&"
import script from "./PerfilAcessoEdit.vue?vue&type=script&lang=js&"
export * from "./PerfilAcessoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports